<template>
  <span class="tag" :class="isSelected ? 'tag--selected' : ''">{{tag}}</span>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    tag: String,
    isSelected: Boolean
  }
}
</script>

<style lang="scss" scoped>
  .tag {
    padding: 2px 8px;
    white-space: nowrap;
    margin-right: 12px;
    background-color: #ffffff;
    border-radius: 8px;
    font-size: 11px;
    text-transform: uppercase;
    color: #494949;
    font-weight: 700;
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.1);

    &--selected{
      background-color: #494949;
      color: #ffffff;
    }
  }
</style>
